import moment from 'moment';
import { VoucherCategory } from '../../vouchers/index.js';
import helpers from '../index.js';
export const money = (n) => n * 100;
export const calcCollectionCostGen = (selfCollectionCosts, foreignCollectionCosts) => async (caseVouchers, documents, economyPolicy, fixedDistributions, selfCollection, conditions) => {
    const distributedVouchers = await helpers.interest.calculate(caseVouchers, documents, economyPolicy, fixedDistributions, moment().format(), conditions);
    const principalTotalAmount = Math.round(Math.max(0, -helpers.overview.balanceCategoryWithDistribution(distributedVouchers.filter((caseVoucher) => {
        // Only calculate costs for over due invoices
        return (new Date(caseVoucher.dueDate || caseVoucher.date).getTime() <
            new Date().getTime());
    }), VoucherCategory.PRINCIPAL)) / 100);
    const costs = selfCollection ? selfCollectionCosts : foreignCollectionCosts;
    for (let i = 0; i < costs.tiers.length; i++) {
        const tier = costs.tiers[i];
        if (tier.from > principalTotalAmount) {
            continue;
        }
        if (tier.to != null && tier.to < principalTotalAmount) {
            continue;
        }
        return tier.value(principalTotalAmount);
    }
    throw new Error('Nonexhaustive costsTable');
};
//# sourceMappingURL=common.js.map